import moment from 'moment';

export default function validateEndTime(start, end){
    return moment(end, ['hh:mm A']).diff(moment(start, ['hh:mm A'])) > 0;
}